
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-brands",
      function () {
        return require("private-next-pages/for-brands.tsx");
      }
    ]);
  